module.exports = __webpack_public_path__ + "linea-ecommerce-10.e8892174d7f87530f38e.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module chunks = styles